import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import TextInput from "../../widgets/TextInput";
import getInsegnanti from '../../services/getInsegnanti';
import updateInsegnante from '../../services/updateInsegnante';
import getMaterie from '../../services/getMaterie';
import updateMateria from '../../services/updateMateria';
import getUtente from '../../services/getUtente';
import getSetting from '../../services/getSetting';
import sendMail from '../../services/sendMail';
import addMateria from '../../services/addMateria';
import FixButton from "../../widgets/Button";
import SelectInput from "../../widgets/SelectInput";
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../utils/Locales";
import getClient from "../../services/getClient";
import { teacherCredentialsMail } from "../../utils/consts";
import Utils from "../../utils/utils";

let t = translateString;

export default class EditInsegnante extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      nome: '',
      cognome: '',
      mail: '',
      mail2Tipo: '',
      mail2: '',
      indirizzo: '',
      citta: '',
      codiceFiscale: '',
      telefono: '',
      telefono2Tipo: '',
      telefono2: '',
    }

    this.grid = 2;

    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {
        isLoading: true, 
        sesso: undefined,
    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
    this.dbPath = cookies.get('db_path', { path: '/' });

    Utils.setAnalyticsPage('Teacher edit: ' + cookies.get('currentInsegnante', { path: '/' }) + ' - ' + cookies.get('db', { path: '/' }));

    this.insegnanti = await getInsegnanti(username, token);
    this.insegnante = undefined;

    this.insegnanti.forEach(i => {
      if (i.id == currentInsegnante)
        this.insegnante = i;
    });

    this.materie = await getMaterie(username, token);
    this.materieOriginali = [];
    this.materieInsegnante = [];
    this.sessoArray = [];

    this.sessoArray.push({ value: 'M', label: t('M') });
    this.sessoArray.push({ value: 'F', label: t('F') });
    this.sessoArray.push({ value: 'A', label: t('A') });

    this.materie.map(r => {
        if (this.insegnante.id == r.id_insegnante && r.active == 1){
          this.materieOriginali.push({value: r.id, label: r.materia.replace(/\\/g, '')});
          this.materieInsegnante.push({value: r.id, label: r.materia.replace(/\\/g, '')});
        }
  });

    this.setState({
      insegnante: this.insegnante,
      materieOriginali: this.materieOriginali,
      materie: this.materieInsegnante,
      inputCorso: '', 
      isLoading: false,
      sessoArray: this.sessoArray,
      sesso: { value: this.insegnante.sesso, label: t(this.insegnante.sesso) },
    });
  }

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />
    if (this.state.insegnante == undefined) return <div/>;

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('modifica_insegnante')} />
          
          <div style={{ display: 'flex' }}>
          <div>
          <TextInput name={'Nome'} value={this.state.insegnante.nome} 
            onChange={(text) => { this.setState(prevState => ({
              insegnante: {
                ...prevState.insegnante,           
                nome: text
              }
            }))}}
            
          />
          <TextInput name={t('cognome')} value={this.state.insegnante.cognome} 
                        onChange={(text) => { this.setState(prevState => ({
                          insegnante: {
                            ...prevState.insegnante,           
                            cognome: text
                          }
                        }))}} /
          >
          <br/>
          <FixButton title={t('invia_credenziali')} callback={async () => {
            if (window.confirm(t('conferma_invio_credenziali')) == false) return;

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
            const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });
            const db = cookies.get('db', { path: '/' });
            var utente = await getUtente(username, token, 2, currentInsegnante);

            if (utente == undefined){
              Utils.showError(t('utente_n_definito'));
              return;
            }

            var loginUsername = utente.username;
            var loginPassword = utente.clear_password;
            
            var indirizzi = '';
            var nomi = '';
            if (this.state.insegnante.mail != ''){
              indirizzi += this.state.insegnante.mail;
              nomi += this.state.insegnante.nome + ' ' + this.state.insegnante.cognome;
            }
            if (this.state.insegnante.mail2 != ''){
              if (indirizzi != '') indirizzi += '---';
              if (nomi != '') nomi += '---';

              indirizzi += this.state.insegnante.mail2;
              nomi += this.state.insegnante.nome + ' ' + this.state.insegnante.cognome;
            }

            this.mail = await getSetting(username, token, 'sendingMailAddress');
            if (this.mail === '') {
              Utils.showError(t('errore_manca_mail'));
              return;
            }
            this.mailName = await getSetting(username, token, 'sendingMailPassword');
            if (this.mailName === '') {
              Utils.showError(t('errore_manca_mail'));
              return;
            }
            this.cliente = await getClient('', '', db);

            const subject = 'Invio credenziali ' + this.cliente.ragioneSociale;
            var body = teacherCredentialsMail(loginUsername, loginPassword, this.cliente.ragioneSociale, db, utente.security_token, this.state.insegnante.sesso);
            await sendMail(username, token, this.mail, this.mailName, indirizzi, nomi, '', subject, body);

          }} />

          <br/>

          <div key={Math.random()}>
            <SelectInput 
                ref={this.selectRef}
                value={this.state.sesso} 
                name={t('sesso')} 
                hidable={false}
                options={this.state.sessoArray} 
                onChange={(option) => 
                    this.setState({ sesso: option })} 
                />
          </div>
          <br/><br/>
          <div style={{ marginTop: -12 }} key={Math.random()}>
            <SelectInput 
                ref={this.selectRef}
                value={this.state.materie} 
                name={t('materia')} 
                hidable={false}
                options={this.state.materie} 
                isMulti={true}
                onChange={(option) => 
                    this.setState({materie: option})} 
                />
          </div>

          <TextInput name={t('aggiungi_corso')} value={this.state.inputCorso} 
                        onChange={(text) => { this.setState({inputCorso: text})}} />  
          <FixButton title={t('aggiungi').charAt(0).toUpperCase() + t('aggiungi').toLowerCase().slice(1)} callback={() => {
            let newArray = this.state.materie;
            newArray.push({value: Math.random(), label: this.state.inputCorso});
            this.setState({
              materie: newArray,
              inputCorso: ''
            })
          }} />

          <TextInput name={'Mail'} value={this.state.insegnante.mail} 
                        onChange={(text) => { this.setState(prevState => ({
                          insegnante: {
                            ...prevState.insegnante,           
                            mail: text
                          }
                        }))}} /
          >
          </div>
          <div style={{ marginLeft: 20 }}>
          <TextInput name={'Mail 2'} value={this.state.insegnante.mail2} 
                        onChange={(text) => { this.setState(prevState => ({
                          insegnante: {
                            ...prevState.insegnante,           
                            mail2: text
                          }
                        }))}} />     

          <TextInput name={t('indirizzo')} value={this.state.insegnante.indirizzo} 
            onChange={(text) => { this.setState(prevState => ({
              insegnante: {
                ...prevState.insegnante,           
                indirizzo: text
              }
            }))}} />
          <TextInput name={t('citta')} value={this.state.insegnante.citta} 
            onChange={(text) => { this.setState(prevState => ({
              insegnante: {
                ...prevState.insegnante,           
                citta: text
              }
            }))}} />
            
          <TextInput name={t('codice_fiscale')} value={this.state.insegnante.codiceFiscale} 
            onChange={(text) => { this.setState(prevState => ({
              insegnante: {
                ...prevState.insegnante,           
                codiceFiscale: text
              }
            }))}} />
            <TextInput name={t('p_iva')} value={this.state.insegnante.piva} 
            onChange={(text) => { this.setState(prevState => ({
              insegnante: {
                ...prevState.insegnante,           
                piva: text
              }
            }))}} />
          <TextInput name={t('telefono')} value={this.state.insegnante.telefono} 
            onChange={(text) => { this.setState(prevState => ({
              insegnante: {
                ...prevState.insegnante,           
                telefono: text
              }
            }))}} />
          <TextInput name={t('telefono') + ' 2'} value={this.state.insegnante.telefono2} 
            onChange={(text) => { this.setState(prevState => ({
              insegnante: {
                ...prevState.insegnante,           
                telefono2: text
              }
            }))}} />
          <TextInput name={t('telefono_note')} value={this.state.insegnante.telefono2_tipo} 
            onChange={(text) => { this.setState(prevState => ({
              insegnante: {
                ...prevState.insegnante,           
                telefono2_tipo: text
              }
            }))}} />
          </div>
          </div>
          <br/>
          <FixButton title={t('salva')} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </>
    );
  }

  async save (){
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });

      // controllo materie insegnanti
      this.state.materieOriginali.forEach(async mOrig => {
        var mOrigFound = false;
        this.state.materie.forEach( mInsegnante => {
          if (mInsegnante.value == mOrig.value)
            mOrigFound = true;
        });
        if (mOrigFound == false){
          // se è stata eliminata qualche materia dell'insegnante
          // la metto in stato NON ATTIVO
          await updateMateria(username, token, mOrig.value, 0);
        }
      });

      this.state.materie.forEach(async mInsegnante => {
        var mOrigFound = false;
        this.state.materieOriginali.forEach(mOrig => {
          if (mInsegnante.value == mOrig.value)
            mOrigFound = true;
        });
        // se è stata aggiunta qualche materia che prima non era prevista
        if (mOrigFound == false){
          await addMateria(username, token, this.state.insegnante.id, mInsegnante.label);

        }
      });

      await updateInsegnante(username, token, this.state.insegnante.id, this.state.insegnante.cognome, this.state.insegnante.nome, this.state.sesso.value, this.state.insegnante.mail
        , this.state.insegnante.mail2, this.state.insegnante.indirizzo, this.state.insegnante.citta, this.state.insegnante.codiceFiscale
        , this.state.insegnante.piva, this.state.insegnante.telefono, this.state.insegnante.telefono2_tipo, this.state.insegnante.telefono2);

      window.location.href =  '/' + this.dbPath + '/#/app/insegnanti';
  }

}

